package com.arena_web.data.api

import com.arena_web.analytics.AnalyticsBatchRequest
import com.arena_web.core.config.AppConfig
import com.arena_web.utils.Storage
import com.arena_web.utils.StorageKeys
import io.ktor.client.*
import io.ktor.client.request.*
import io.ktor.http.*

/**
 * Fire-and-forget analytics ingestion endpoint. The backend accepts batches
 * with OR without an Authorization header, so this API always uses the
 * default (unauthenticated) client and opportunistically attaches the Bearer
 * token from localStorage when the user is logged in.
 */
class AnalyticsApi(private val client: HttpClient) {

    /** Returns true when the backend accepted the batch (2xx, normally 202). */
    suspend fun sendBatch(request: AnalyticsBatchRequest): Boolean {
        val response = client.post(batchUrl()) {
            contentType(ContentType.Application.Json)
            Storage.get(StorageKeys.ACCESS_TOKEN)?.let { token ->
                header(HttpHeaders.Authorization, "Bearer $token")
            }
            setBody(request)
        }
        return response.status.isSuccess()
    }

    companion object {
        /** Shared with the `navigator.sendBeacon` page-close path. */
        fun batchUrl(): String = AppConfig.getApiUrl("v1/analytics/events/batch")
    }
}
